














import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { HomeBanner } from '@/types/home';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from './components/content-loader.vue';
import { defineComponent, ref, onMounted } from '@vue/composition-api';
import { getMidBannerData } from './api';
import LeftBanner from './components/left-banner.vue';
import RightTopBanner from './components/right-top-banner.vue';
import RightBottomBanner from './components/right-bottom-banner.vue';

export default defineComponent({
  name: 'MidBanner',
  components: {
    BaseComponent,
    ContentLoader,
    LeftBanner,
    RightTopBanner,
    RightBottomBanner,
  },
  setup() {
    // 中部banner是否准备完毕
    const isMidBannerReady = ref(false);
    const leftBannerList = ref<HomeBanner[]>([]);
    const rightTopBanner = ref<HomeBanner|null>(null);
    const rightBottomBanner = ref<HomeBanner|null>(null);
    onMounted(async () => {
      const [err, midBannerRes] = await to(getMidBannerData());
      if (err) {
        isMidBannerReady.value = true;
        throw new CustomException(err, 'getMidBannerDataFail', '获取中部banner数据失败');
      }
      leftBannerList.value = midBannerRes.leftBannerList;
      rightTopBanner.value = midBannerRes.rightTopBanner;
      rightBottomBanner.value = midBannerRes.rightBottomBanner;
      isMidBannerReady.value = true;
    });
    return {
      isMidBannerReady,
      leftBannerList,
      rightTopBanner,
      rightBottomBanner,
    };
  },
});
